import {Component, OnInit} from '@angular/core';
import {QFilterModel} from '../../../../models/qfilter.model';
import {IndicatorsChartService, IndicatorsService} from '../../../../services/indicators/indicators.service';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {SearchToolbarModelFactoryService} from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {TranslateService} from '@ngx-translate/core';
import {LoyaltyChart} from '../../../../models/loyalty-chart-config.model';

@Component({
  selector: 'app-analysis-single-store-trend',
  templateUrl: './analysis-single-store-trend.component.html',
  styleUrls: ['./analysis-single-store-trend.component.css']
})
export class AnalysisSingleStoreTrendComponent implements OnInit {

  public data: QFilterModel;

  translations: any;

  public trendChart: LoyaltyChart;
  public indicators: IndicatorBoxModel[] = [];
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  public storeError = false;
  public selectOneError: string;

  constructor(
    private translate: TranslateService,
    private indicatorService: IndicatorsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private chartsService: IndicatorsChartService,
  ) { }

  ngOnInit() {
    this.translations = {
      etichetta_week: ''
    };

    this.translate.get([
      'store.selectOneErrorMsg',
      'loyalty_chart.period'
    ]).subscribe(t => {
      this.selectOneError = t['store.selectOneErrorMsg'];
      this.translations.etichetta_periodo_commerciale = t['loyalty_chart.period'];

      this.initCharts();
    });

    // this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
  }

  private initCharts() {
    this.trendChart = (new LoyaltyChart('line', '€'));
    this.trendChart.options.xAxis.title.text = this.translations.etichetta_periodo_commerciale;
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;
    if (data['stores'] != null) {
      this.translate.get([
        'indicator.fatturato',
        'indicator.scontrini',
        'indicator.fatturato_mq',
        'indicator.scontrino_medio',
        'indicator.media_clienti_settimanali',
        'indicator.incidenza_carta',
        'indicator.incidenza_promo',
        'indicator.nuovi_clienti',
      ]).subscribe(t => {
        this.indicators = [];
        this.indicatorService.indicatorCalculation('stores.Q077', this.data).subscribe((res) => {
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'fatturato')], {dynamic: true, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'scontrini')], {decimal_value: 0, decimal_prec_value: 0}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'fatturato_mq')], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'incidenza_carta')], {unit_period_prec: '%'}, t));
        });
        this.chartsService.loadChart(this.trendChart, 'stores.Q095', data, this.indicatorService, this.translate, true);
      });
    } else {
      this.data = null;
      this.storeError = true;
    }
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public resetData() {
    this.data = null;
    this.indicators = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store-trend/analysis-single-store-trend.component.ts